if (!customElements.get('article-floating-product')) {
  customElements.define(
    'article-floating-product',
    class ArticleFloatingProduct extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-floating-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-floating-dots] .article-floating-product__dot'));
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.index = 0;

        if (this.slides.length < 2) return;

        this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
        this.show(this.index);
      }

      goTo(nextIndex) {
        const total = this.slides.length;
        this.index = ((nextIndex % total) + total) % total;
        this.show(this.index);
      }

      show(index) {
        this.slides.forEach((slide, i) => {
          if (i === index) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }
    }
  );
}
